import React from 'react';
import PropTypes from 'prop-types';
import RemovableImage from '../../removable-image';

const UploadCompletedComponent = (
  {
    imageUrl,
    imageKey,
    onRemove,
    maxHeight,
    canRemoveImage,
  },
) => (
  <RemovableImage
    src={imageUrl}
    alt={imageKey}
    onRemove={onRemove}
    maxHeight={maxHeight}
    canRemoveImage={canRemoveImage}
  />
);

UploadCompletedComponent.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  imageKey: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  maxHeight: PropTypes.string.isRequired,
  canRemoveImage: PropTypes.bool.isRequired,
};

export default UploadCompletedComponent;
